module.exports = __webpack_public_path__ + "static/media/ic_checkBox_blue.4cad503b.svg";